import { ECO_SAVER_TOAST_FREQUENCY_CAPPING_ID } from "@cart-client/constants/index";
import { SessionVisibility } from "@swiggy-private/checkout-core";
import { LOCAL_STORAGE_KEYS } from "@swiggy-private/core-ui";

export const FREQUENCY_CAP_PAYLOAD = {
    id: ECO_SAVER_TOAST_FREQUENCY_CAPPING_ID,
    key: LOCAL_STORAGE_KEYS.ECO_SAVER_TOAST_FREQUENCY_CAPPING_KEY,
    sessionVisibility: SessionVisibility.ONCE_PER_SESSION,
    disableMaxFrequency: true,
};
